import PropTypes from "prop-types";
import { memo } from "react";
// @mui
import { AppBar, Box, Toolbar } from "@mui/material";
import { useTheme } from "@mui/material/styles";
// config
import { HEADER } from "../../../config-global";
// utils
import { bgBlur } from "../../../utils/cssStyles";
// components
import { NavSectionHorizontal } from "../../../components/nav-section";
//
import { useSelector } from "react-redux";
import { PATH_DASHBOARD } from "../../../routes/paths";
import navConfig from "./config-navigation";

// ----------------------------------------------------------------------

function NavHorizontal() {
  const theme = useTheme();

  const { categories } = useSelector((state) => state.category);

  const parentCategories =
    categories?.data?.filter((cat) => cat.parent_id === null) || [];

  const augmentedConfig = navConfig.map((group) => {
    if (group.subheader === "Order Management") {
      return {
        ...group,
        items: group.items.map((item) => {
          if (item.title === "Orders" || item.title === "Orders List") {
            const children = item.children
              ? [...item.children]
              : [{ title: "Orders List", path: item.path }];
            return {
              ...item,
              title: "Orders",
              path: PATH_DASHBOARD.orders.root,
              children: [
                ...parentCategories.map((cat) => ({
                  title: cat.name,
                  path: `${PATH_DASHBOARD.orders.list}?category=${cat.slug}`,
                })),
                ...children,
              ],
            };
          }
          return item;
        }),
      };
    }
    if (group.subheader === "Stock Management") {
      return {
        ...group,
        items: group.items.map((item) => {
          if (item.title === "Stock Histories") {
            const children = item.children ? [...item.children] : [];
            return {
              ...item,
              children: [
                ...parentCategories.map((cat) => ({
                  title: cat.name,
                  path: `${PATH_DASHBOARD.stockHistories}?category=${cat.slug}`,
                })),
                ...children,
              ],
            };
          }
          return item;
        }),
      };
    }
    return group;
  });

  return (
    <AppBar
      component="nav"
      color="transparent"
      sx={{
        boxShadow: 0,
        top: HEADER.H_DASHBOARD_DESKTOP_OFFSET,
      }}
    >
      <Toolbar
        sx={{
          ...bgBlur({
            color: theme.palette.background.default,
          }),
        }}
      >
        <NavSectionHorizontal data={augmentedConfig} />
      </Toolbar>

      <Shadow />
    </AppBar>
  );
}

export default memo(NavHorizontal);

// ----------------------------------------------------------------------

Shadow.propTypes = {
  sx: PropTypes.object,
};

function Shadow({ sx, ...other }) {
  return (
    <Box
      sx={{
        left: 0,
        right: 0,
        bottom: 0,
        height: 24,
        zIndex: -1,
        width: 1,
        m: "auto",
        borderRadius: "50%",
        position: "absolute",
        boxShadow: (theme) => theme.customShadows.z8,
        ...sx,
      }}
      {...other}
    />
  );
}
